import React from 'react';
import { Globe, Activity, BarChart2, Stethoscope } from 'lucide-react';
import ConfigCard from '../ConfigCard';

const ComplianceTab = ({ configData, cardProps }) => (
  <div className="space-y-6">
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      <ConfigCard {...cardProps} title="Foreign Worker Levies" icon={Globe}
        items={configData.foreignWorkerLevies}
        category="foreignWorkerLevies"
        fields={['pass_type', 'sector', 'levy_rate_monthly']}
      />
      <ConfigCard {...cardProps} title="WICA Compensations" icon={Activity}
        items={configData.wicaCompensations}
        category="wicaCompensations"
        fields={['injury_type', 'compensation_cap']}
      />
    </div>
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      <ConfigCard {...cardProps} title="Work Pass Quotas" icon={BarChart2}
        items={configData.workPassQuotas}
        category="workPassQuotas"
        fields={['pass_type_display', 'sector', 'monthly_quota_limit']}
      />
      <ConfigCard {...cardProps} title="Medical Exams" icon={Stethoscope}
        items={configData.medicalExams}
        category="medicalExams"
        fields={['exam_type_display', 'frequency_months']}
      />
    </div>
  </div>
);

export default ComplianceTab;
